<script>
import { donationCurrencySymbol } from '@/constants/currencies.js'

export default {
  name: 'TwAmount',
  props: {
    modelValue: {
      type: [String,Number],
      default: null
    },
    label: {
      type: String,
      default: null
    },
    helpText: {
      type: String,
      default: null
    },
    smallLabel: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: () => Math.random().toString(36).substring(7)
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    prepend: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    },
    currency: {
      type: String,
      default: 'USD'
    }
  },
  emits: ['update:modelValue', 'update'],
  computed: {
    textSize() {
      return [
        {'text-sm': !this.size},
        {'text-2xl': this.size === 'lg'},
        {'text-sm': this.size === 'sm'},
      ]
    },
    inputClasses() {
      return [
        'block w-full rounded-md border-0 pr-20 text-gray-900 ring-1 ring-inset ring-gray-300 hover:ring-gray-400 placeholder:text-gray-400 focus:ring-1 focus:ring-inset text-sm focus:ring-gray-800',
        {'pl-7 py-2 min-h-[44px]': !this.size},
        {'pl-10 py-3 text-xl': this.size === 'lg'},

        {'': this.size === 'sm'}, //
      ]
    },
    currencySymbol() {
      return donationCurrencySymbol(this.currency)
    },
  }
}
</script>

<template>
  <div class="w-full">
    <label v-if="label" :for="id" class="form-label flex items-center">
      {{ label }}
      <i v-if="helpText" :for="id" class="pi pi-question-circle ml-2" />
    </label>
    <div v-if="smallLabel || $slots.smallLabel" class="form-label-sm">
      <slot name="smallLabel">
        {{ smallLabel }}
      </slot>
    </div>
    <div v-if="disabled" class="font-forms">
      {{ currencySymbol }} {{ modelValue? modelValue:null }}
    </div>
    <div v-else class="relative rounded-md">
      <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 font-forms">
        <span :class="['text-gray-500', ...textSize]">{{ currencySymbol }}</span>
      </div>
      <input :id="id" :required="required" :value="modelValue" type="number" :name="id" :autocomplete="id" :class="inputClasses" :placeholder="placeholder" @input="$emit('update:modelValue', $event.target.value)">
      <div class="absolute inset-y-0 right-0 flex items-center">
        <label for="currency" class="sr-only">Currency</label>
        <select id="currency" name="currency" class="h-full rounded-md border-0 bg-transparent py-0 pl-2 pr-7 text-gray-500 focus:ring-1 focus:ring-inset focus:ring-gray-800 ">
          <option>{{ currency }}</option>
        </select>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
